(function () {
  // Event delegation (funziona anche con app/Theme Editor)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.ss-desc__toggle');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const wrap = btn.closest('.ss-desc');
    if (!wrap) return;

    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    wrap.classList.toggle('is-expanded', !expanded);

    btn.textContent = expanded ? 'VEDI TUTTI I DETTAGLI' : 'RIDUCI';
  }, true);
})();